export const FREE_DRAW_NODE_MAIN_SHAPE_NAME = 'FD_MAIN_SHAPE';
